import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {observable, action} from 'mobx';
import { Grid, TextField, Button } from '@material-ui/core';
import AuthStore from 'src/stores/AuthStore';

export interface ILoginFormProps {
    authStore?: AuthStore;
}

@inject('authStore')
@observer
class LoginForm extends React.Component<ILoginFormProps>{

    @observable private user: string = '';
    @observable private heslo: string = '';

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    @action
    private handelLogin = evnt => {
        this.props.authStore.auth(this.user, this.heslo);
    }

    public render() {
        return (
            <Grid container style={{flexGrow: 1}}>
                <Grid item xs={12}>
                    <Grid container justify="center" style={{margin: 'auto', width: '300px'}}>
                        <Grid item xs={12}>
                        <TextField
                            id="standard-user"
                            label="Jméno"
                            value={this.user}
                            onChange={this.handleChange('user')}
                            margin="normal"/>
                        </Grid>
                        <Grid item xs={12}>
                        <TextField
                            id="standard-password"
                            label="Heslo"
                            value={this.heslo}
                            type="password"
                            onChange={this.handleChange('heslo')}
                            margin="normal"/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" onClick={this.handelLogin}>
                                Přihlásit
                            </Button>
                        </Grid>                    
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm.tsx